module.exports = __webpack_public_path__ + "static/video-placeholder-a20370f491dfddcde10c60b8441243c2.jpg";